import Settings from '_modules/settings/views/Settings.vue';
import settingsMiddleware from '../../../router/middlewares/settingsMiddleware';

export default {
  path: 'settings',
  name: 'admin-settings',
  beforeEnter: settingsMiddleware,
  component: Settings,
};
